<div class="layout-container">
    <app-operations [isCollapsed]="isCollapsed"></app-operations>
    <div class="main-content">
        <app-top-bar (toggleSidebar)="handleToggle()"></app-top-bar>
        <div class="content-area">
          <div class="d-flex justify-content-between align-items-center mb-3">
                <h5 class="fw-semibold">View Layout</h5>
            </div>
            <hr />
            <div class="row" [formGroup]="layoutForm">
                <div class="col-12 text-start" *ngIf="!displayLayout">
                    <ul class="nav nav-tabs custom-tabs">
                        <li class="nav-item">
                            <a class="nav-link active" data-bs-toggle="tab" href="#view-layout">View Layout</a>
                        </li>
                    </ul>
                    <div class="tab-content">
                        <div class="tab-pane fade show active" id="view-layout">
                            <div class="p-3">
                                <div class="mb-4">
                                    <label class="form-label fw-semibold">Period</label>
                                    <div class="row">
                                        <div class="col-md-3">
                                            <label class="form-label"><span class="required">*</span>{{ layoutForm.get('rentalType').value === '1' ? 'Layout Date' : 'From Date' }}</label>
                                            <ejs-datepicker #date format='MM/dd/yyyy' [allowEdit]=false
                                                formControlName="fromDate" class="form-control p-0"
                                                (ngModelChange)="checkSelectedMarketDays()"></ejs-datepicker>
                                        </div>
                                        <div class="col-md-3" *ngIf="layoutForm.get('rentalType').value != '1'">
                                            <label class="form-label"><span class="required">*</span>To Date</label>
                                            <ejs-datepicker #date format='MM/dd/yyyy' [allowEdit]=false
                                                formControlName="toDate" class="form-control p-0"
                                                (ngModelChange)="checkSelectedMarketDays()"></ejs-datepicker>
                                        </div>
                                    </div>
                                    <hr />
                                </div>

                                <div class="mb-4">
                                    <label class="form-label fw-semibold"><span class="required">*</span>Rental Type</label>
                                    <br />
                                    <div class="form-check form-check-inline">
                                        <input class="form-check-input" type="radio" value="1" id="Daily"
                                            formControlName="rentalType" [attr.disabled]="!daily ? true : null"
                                            (change)="checkForMarketDays()">
                                        <label class="form-check-label" for="daily">Daily</label>
                                    </div>
                                    <div class="form-check form-check-inline">
                                        <input class="form-check-input" type="radio" value="5" id="CombinedWeekly"
                                            formControlName="rentalType" [attr.disabled]="!combinedWeekly ? true : null"
                                            (change)="checkForMarketDays()">
                                        <label class="form-check-label" for="weekly">Weekly</label>
                                    </div>
                                    <div class="form-check form-check-inline">
                                        <input class="form-check-input" type="radio" value="4" id="CombinedMonthly"
                                            formControlName="rentalType"
                                            [attr.disabled]="!combinedMonthly ? true : null"
                                            (change)="checkForMarketDays()">
                                        <label class="form-check-label" for="monthly">Monthly</label>
                                    </div>
                                    <hr />
                                </div>

                                <div class="mb-4">
                                    <label class="form-label fw-semibold"><span class="required">*</span>Market Days</label>
                                    <div class="d-flex flex-wrap" formGroupName="marketDays">
                                        <div *ngFor="let day of days" class="form-check me-3">
                                            <input class="form-check-input" type="checkbox" [id]="day"
                                                [formControlName]="day" (change)="checkMarketDay(day)">
                                            <label class="form-check-label ms-1" [for]="day">{{ day }}</label>
                                        </div>
                                    </div>
                                    <hr />
                                </div>

                                <div class="mb-4">
                                    <div class="row">
                                        <div class="col-md-6 col-lg-4 col-xl-3 text-start">
                                            <label for="parts" class="form-label fw-semibold"><span class="required">*</span>Parts</label>
                                            <select class="form-select" formControlName="layoutParts">
                                                <option [value]="null" disabled>Select</option>
                                                <option *ngFor="let item of parts" [value]="item.PartId">
                                                    {{item.PartDescription}}</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row pe-3">
                                <div class="col-12 text-end my-3">
                                    <button class="btn btnAS me-1" [disabled]="disableViewButton || layoutForm.get('layoutParts')?.invalid"
                                        (click)="viewLayout()">View Layout</button>
                                    <button class="btn btn-orange" (click)="cancelLayout()">Cancel</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div *ngIf="displayLayout">
                  <div class="row my-2" formGroupName="layoutDiagramFilter">
                    <div class="col-md-4 align-items-center d-flex legendDropDown">
                      <label style="width: 170px;" i18n>Category Legend</label> &nbsp; &nbsp;
                      <div class="custom-dropdown form-control" style="text-align: right;justify-content: end;"
                           (click)="toggleDropdown()">
                        <i class="fas fa-chevron-down" x></i>
                        <div *ngIf="isDropdownOpen" class="dropdown-list" (click)="stopPropagation($event)">
                          <div *ngFor="let category of categoryLegend" class="color-option"
                               (click)="closeCategoryLegend()">
                            <span class="color-text">{{ category.categoryName }}</span>
                            <span class="color-box" [style.background-color]="category.color"></span>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="col-md-3 d-flex align-items-center" style="min-width: 250px;">
                      <label i18n>{{ 'Find Booth' | wordReplace }}</label>&nbsp;&nbsp;
                      <div class="input-group">
                        <input type="text" class="form-control" placeholder="Search" formControlName="searchBooth"
                               (blur)="changeSearchText()">
                        <div class="input-group-append" (click)="searchNodes()">
                          <span class="input-group-text ms-2" style="padding-bottom: 10px; padding-top: 10px;">
                            <i class="fa fa-search text-white"></i>
                          </span>
                        </div>
                      </div>
                    </div>

                    <div class="col-md-3 d-flex align-items-center" style="min-width: 240px;">
                      <button class="btn-outline-primary zoom-btn mr-2" style="background-color: #F4F4F4" (click)="layoutZoomInClick($event)">
                        <img src="../assets/images/ZoomIn.svg" class="img-fluid" />
                      </button>
                      <button class="btn-outline-info zoom-btn mr-2" style="background-color: #F4F4F4" (click)="layoutZoomOutClick($event)">
                        <img src="../assets/images/ZoomOut.svg" class="img-fluid" />
                      </button>
                      <button class="btn zoom-btn" style="min-width: 65px;" (click)="printDiagram()">
                        <img src="../assets/images/PrintLayout.svg" class="img-fluid" />
                      </button>
                    </div>

                    <div class="col-md-2 d-flex align-items-center justify-content-end" style="min-width: 160px;">
                      <button type="button" i18n class="btn btn-orange" (click)="closeLayoutForm()">Close</button>
                    </div>
                  </div>

                  <div class="row my-2" formGroupName="layoutDiagramFilter">
                    <div class="col-md-12 align-items-center" style="font-weight: bold;text-align: center;">
                      Part: {{selectedPartName}}
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12 text-center">
                      <div class="layoutDiagramSection" id="diagram-container">
                        <ejs-diagram #diagram width="100%" [selectedItems]="selectedItems" [tooltip]="tooltip" [tool]="tool"
                                     [snapSettings]='snapSettings' (mouseover)="nodeMouseOver($event)"></ejs-diagram>
                      </div>
                    </div>
                  </div>
                </div>
            </div>
        </div>
    </div>
</div>
